export default __webpack_public_path__ + "static/media/co.2035da4e.svg";